import routePaths from 'const/routePaths'
import React, { ErrorInfo, ReactNode } from 'react'
import { Redirect } from 'react-router-dom'
import { ErrorBoundaryProps, ErrorBoundaryState } from './typing'

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // Reset any styles modified by component library
    document.body.style.overflow = 'auto'
  }

  render(): ReactNode {
    const { children, fallbackComponent: FallbackComponent } = this.props
    const { hasError } = this.state

    if (hasError) {
      if (FallbackComponent) {
        return <FallbackComponent />
      }
      return <Redirect push to={routePaths.error} />
    }

    return children
  }
}

export default ErrorBoundary
